import { useState } from 'react';
import { Icon } from '../../../shared/Icon';
import { speakNorwegian } from '../../../shared/speech';
import type { ExercisePluginProps } from '../types';
import { objects, strings, text } from '../contentFields';

export function PronunciationExercise({ exercise, onComplete, showToast }: ExercisePluginProps) {
  const [saving, setSaving] = useState(false);
  const models = objects(exercise.content, 'models');

  function play(value: string) {
    if (!speakNorwegian(value)) showToast('Lyd er ikke tilgjengelig i denne nettleseren.');
  }

  async function finish(clearContrast: boolean) {
    setSaving(true);
    await onComplete({
      response: { selfAssessment: clearContrast ? 'clear' : 'retry' },
      result: { selfAssessed: true, clearContrast },
      evidence: exercise.targets.map(itemId => ({ itemId, dimension: 'produced', value: clearContrast ? 0.65 : 0.2 })),
      repeat: !clearContrast
    });
  }

  return <>
    <p className="exercise-kicker">UTTALE · LYTT OG SAMMENLIGN</p>
    <h2 className="exercise-title">Hører du forskjellen?</h2>
    <p className="exercise-intro">{text(exercise.content, 'instruction')}</p>
    <div className="pronunciation-models">{models.map(model => {
      const value = text(model, 'text');
      return <button key={value} onClick={() => play(value)}><Icon name="volume" /><strong>{value}</strong></button>;
    })}</div>
    <div className="must-use"><span>SI REKKEFØLGEN HØYT</span><div className="word-chips">{strings(exercise.content, 'productionSequence').map(value => <i key={value}>{value}</i>)}</div></div>
    <div className="feedback-box"><h4>Artikulasjonstips</h4><p>{text(exercise.content, 'articulationHint')}</p></div>
    <p className="exercise-intro">Vurder bare om kontrasten var tydelig. Nettleseren analyserer ikke opptaket.</p>
    <div className="rating-row"><button disabled={saving} onClick={() => finish(false)}>Prøv igjen</button><button disabled={saving} onClick={() => finish(true)}>Tydelig forskjell</button></div>
  </>;
}
